import  axiosInstance  from "../utils/api";
 
import endpoints from "../constants/endpoints";



export const PaymentsApi = {

    fetchListOfPaymentsForTheAdmin: async () => {
        try {
            const response = await axiosInstance.get(endpoints.fetchListPaymentsForTheAdmin);
            return response.data;
        } catch (error) {
            console.error("Error fetching payments:", error);
            throw error;
        }
    },
    searchAndFilterPaymentAdminSide: async (searchTerm, formData) => {
        try {
            const response = await axiosInstance.post(endpoints.searchAndFilterPayments(searchTerm), formData);
            return response.data;
        } catch (error) {
            console.error("Error searching and filtering payments:", error);
            throw error;
        }
    },
    fetchSinglePaymentTransactionDetail: async (transactionId) => {
        try {
            const response = await axiosInstance.get(endpoints.fetchSinglePaymentTransaction(transactionId));
            return response.data;
        } catch (error) {
            console.error("Error fetching payment transaction detail:", error);
            throw error;
        }
    },

}